import { InfoCircledIcon } from '@radix-ui/react-icons';
import { formatHostDate } from '@/utils/formatUserId';

export function PossibleBannedDeviceTag({
  matchedBanCreatedAt,
}: {
  matchedBanCreatedAt?: string | Date | null;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span
        className="inline-flex w-fit items-center gap-1 rounded-md border px-1.5 py-0.5 font-semibold text-amber-400"
        style={{
          fontSize: 11,
          background: 'hsl(38 92% 50% / 0.1)',
          borderColor: 'hsl(38 92% 50% / 0.32)',
        }}
      >
        <InfoCircledIcon className="h-3 w-3" />
        Possible banned device
      </span>
      {matchedBanCreatedAt && (
        <p className="text-[12px] text-amber-200/70">
          Matches a device banned on {formatHostDate(matchedBanCreatedAt)}.
          Review before approving.
        </p>
      )}
    </div>
  );
}
